import { render, staticRenderFns } from "./Antifraud.vue?vue&type=template&id=5ff0f6b2&scoped=true"
import script from "./Antifraud.vue?vue&type=script&lang=js"
export * from "./Antifraud.vue?vue&type=script&lang=js"
import style0 from "./Antifraud.vue?vue&type=style&index=0&id=5ff0f6b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff0f6b2",
  null
  
)

export default component.exports